import { GET_STORE_DATA_REQUEST, GET_STORE_DATA_FAILURE, GET_STORE_DATA_RESET, GET_STORE_DATA_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    isLoading: false,
    error: null,
};
const getStoreDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_STORE_DATA_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case GET_STORE_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, isLoading: false, error: null });
        case GET_STORE_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case GET_STORE_DATA_RESET:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
export default getStoreDataReducer;
